export const environment = {
  production: true,
  authEnabled: true,
  apiUrl: 'https://web-carry-bridge-api-dev.azurewebsites.net/api',
  msalConfig: {
    clientId: '668f66d4-3ef5-489a-bcf2-4e1317a579d6',
    authority: 'https://login.microsoftonline.com/cca76bf2-ad28-4adb-bbd0-deeb9dd15a80/v2.0',
    redirectUri: 'https://carry-bridge-dev.blueowl.com'
  },
  apiConfig: {
    scopes: ['api://668f66d4-3ef5-489a-bcf2-4e1317a579d6/access_as_user'],
    uri: 'https://web-carry-bridge-api-dev.azurewebsites.net/*'
  },
  graphConfig: {
    scopes: ['User.ReadBasic.All'],
    uri: 'https://graph.microsoft.com/v1.0/*'
  }
};
